import ReactPopover from "react-popover";
import styled from "styled-components";

export const DropdownMenuWrapper = styled(ReactPopover)`
  min-width: max-content;
  z-index: 10;

  .Popover-tipShape {
    fill: ${({ theme }) => theme.dropdownBg};
  }
`;

export const DropdownMenuBody = styled.div`
  filter: drop-shadow(0 2px 8px ${({ theme }) => theme.shadowColor});
  background-color: ${({ theme }) => theme.dropdownBg};
  border: 1px solid ${({ theme }) => theme.divider};
  border-radius: 4px;
  min-width: 150px;
  overflow: hidden;
`;

interface DropdownMenuItemStyledProps {
  disabled?: boolean;
}

export const DropdownMenuItemStyled = styled.button<DropdownMenuItemStyledProps>`
  display: block;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: none;
  text-align: left;
  font-size: 14px;
  color: ${({ disabled, theme }) => (disabled ? theme.textTertiary : theme.elevatedText)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: background-color 0.2s;
  white-space: nowrap;

  &:hover {
    background-color: ${({ disabled, theme }) => (disabled ? "transparent" : theme.subtleHover)};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.divider};
  }
`;

export const TriggerWrapper = styled.div`
  display: inline-block;
`;
